// extracted by mini-css-extract-plugin
export default {"background":"VK","weightImage":"WK","drinkImage":"XK","content":"YK","rtbLeft":"ZK","rtbRight":"aL","rtbLeftMobile":"bL","imageContainer":"cL","rtbBox":"eL","line":"fL","rtbDesktop":"gL"};
    if(module.hot) {
      // 1713809678554
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  